module.exports = __webpack_public_path__ + "img/274548314_665987407931563_8800439185296945264_n.9e11a920.jpg";